<template>
    <div id="UpdatePassword">
        <nav-bar>
            <div slot="left">
                <van-icon name="arrow-left" color="#666666" size="20" @click="goBack"/>
            </div>
            <div slot="title" style="font-weight: 800; font-size: 15px;  letter-spacing:2px;">{{langText.titleUpdatePassword}}</div>
        </nav-bar>
        <div style="height: 75px; width: 100%;"></div>
        <div style="width: 95%; margin: auto; ">
            <van-form @submit="onSubmit">
                <van-field style="border-top-left-radius: 10px; border-top-right-radius: 10px;"
                           v-model="fromdata.oldpassword"
                           :name="langText.oldPassword"
                           :label="langText.oldPassword"
                           :placeholder="langText.oldPassword"/>

                 <van-field v-model = "fromdata.newpassword"
                           :name = "langText.newPassword"
                           :label = "langText.newPassword"
                           :placeholder = "langText.newPassword"/>

                <van-field style="border-bottom-left-radius: 10px; border-bottom-right-radius: 10px;"
                           v-model="fromdata.againpassword"
                           :name = "langText.repetition"
                           :label = "langText.repetition"
                           :placeholder = "langText.repetition"/>
                <div style="margin: 16px;">
                    <van-button  round block type="info" native-type="submit">{{langText.submit}}</van-button>
                </div>
            </van-form>
        </div>
    </div>
</template>

<script>
    import NavBar from "@/components/common/navbar/NavBar";
    import { Col, Row, Icon, Image, Divider,Form, Field, Cell, CellGroup,Button,Toast} from 'vant'
    import {updatePassword} from "../../network/mine/account.js"

    import { langPackage } from "@/config/lang/accountsLang";
    import { selectLang } from "@/config/setLanguage";

    export default {
        name: "UpdatePassword",
        components: {
            NavBar: NavBar,
            [Col.name]: Col,
            [Row.name]: Row,
            [Icon.name]: Icon,
            [Image.name]: Image,
            [Divider.name]: Divider,
            [Form.name]: Form,
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [Field.name]: Field,
            [Button.name]: Button,
            [Toast.name]: Toast
        },
        data(){
            return{
                fromdata:{
                    oldpassword:"",
                    newpassword:"",
                    againpassword:""
                },
                langText:"",
                commonText:"",
            }
        },
        methods:{
            goBack(){
                this.$router.back();
            },
            onSubmit(){
                if (this.fromdata.oldpassword == "" || this.fromdata.newpassword == "" || this.fromdata.againpassword == ""){
                    Toast.fail("输入的密码不能为空！")
                    return false
                }

                if (this.fromdata.newpassword != this.fromdata.againpassword){
                    Toast.fail("两次密码输入不一致！")
                    return false
                }

                if (this.fromdata.newpassword.length < 8 || this.fromdata.newpassword.length < 8){
                    Toast.fail("密码不能小于8位数！")
                    return false
                }

                Toast.success("正在提交请稍后")
                setTimeout(() => {
                    Toast.clear();
                    let password = {
                        oldPassword: this.fromdata.oldpassword,
                        newPassword: this.fromdata.newpassword
                    }
                    updatePassword(password).then(res => {

                        if (res.code == 200){
                            Toast.success("修改成功");
                        }else {
                            Toast.fail("修改失败");
                        }
                    },error => {
                        Toast.fail("修改失败");
                    })
                }, 1000)

            }

        },
        created() {
            //获取语言包
            selectLang(langPackage).then(langtxt => {
                this.langText = langtxt.langtxt;
                this.commonText = langtxt.common;
            })
        }
    }
</script>

<style scoped>

    #UpdatePassword{
        background: #f8f6f7;
        /*height: 800px;*/
        width: 100%;
    }

</style>
